import getFullComposeViewState from './getFullComposeViewState';

export default function shouldHidePNTInfoBarForSingleProposer(): boolean {
    if (!getFullComposeViewState()) {
        return false;
    }

    return getFullComposeViewState().isAcceptProposeNewTime;
}
